import { useMemo } from "react";
import { useContextModalHardwareInstall } from "../context/modal-hardware-install-context";

const crSelectedProductNumbers = [
  "82",
  "82.2",
  "82.3",
  "82.11",
  "82.12",
  "420.1",
  "701.1",
  "401",
  "403",
];

export function useCrSelected() {
  const { deploymentData } = useContextModalHardwareInstall();

  return useMemo(() => {
    return crSelectedProductNumbers.includes(
      deploymentData?.Product?.ProductNumber || "",
    );
  }, [deploymentData?.Product]);
}
